import { useState, useContext } from "react"
import { useNavigate } from "react-router-dom"

import { Dropdown } from "primereact/dropdown"

import { UserContext } from "../../../../context/userContext"

export default function SelectOrganizationFallback() {
  const [loading, setLoading] = useState(false)
  const userCtx = useContext(UserContext)
  const navigate = useNavigate()

  return (
    <Dropdown
      disabled={loading}
      value={userCtx.session.user.organization_id}
      options={userCtx.session.organizations}
      onChange={async ({ value }) => {
        await userCtx.changeOrganization(value)
        navigate("/")
      }}
      optionLabel="organization_name"
      optionValue="organization_id"
      placeholder="Organizations"
      filter
      style={{ marginBottom: 15 }}
    />
  )
}
